import { combineReducers } from 'redux'

import { topicsReducer } from './topics/reducer'

export type ConfigState = {
  ads: {
    home: { data: {}; index: number }[]
  }
  main: string
  name: string
  pages?: {
    component: string
    programs: {
      title: string
      image: string
      description: string
      path: string
      query: string
    }[]
  }[]
  marketing: {
    url: string
    domain: string
    brand: string
  }
}

const initialState: ConfigState = {} as ConfigState

const configReducer = (state = initialState, action): ConfigState => {
  switch (action.type) {
    case 'LOADING_CONFIG':
      return action.config
    default:
      return state
  }
}

const rootReducer = combineReducers({
  configBrand: configReducer,
  topics: topicsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
